module.exports = __webpack_public_path__ + "7f3a8b6d20d4af8346b63fb93529505e.png";